"use client";

import { useEffect, useRef } from "react";
import Script from "next/script";

export function HubSpotNewsletterForm() {
  const containerRef = useRef<HTMLDivElement>(null);
  const created = useRef(false);

  function createForm() {
    if (created.current || !containerRef.current) return;
    // @ts-expect-error, hbspt is injected by the HubSpot script
    if (typeof window.hbspt === "undefined") return;
    created.current = true;
    // @ts-expect-error -- hbspt is not typed; injected by HubSpot embed script
    window.hbspt.forms.create({
      portalId: "25493898",
      formId: "e39b44be-e5e5-4674-b653-bdd72ccb74e1",
      region: "eu1",
      target: "#hubspot-newsletter-form-target",
    });
  }

  useEffect(() => {
    createForm();
  }, []);

  return (
    <>
      <Script
        src="https://js-eu1.hsforms.net/forms/embed/v2.js"
        strategy="afterInteractive"
        onLoad={createForm}
      />
      <div id="hubspot-newsletter-form-target" className="hs-form-host" ref={containerRef} />
    </>
  );
}
